import { InjectionToken } from '@angular/core';
import { RegistrationConfig } from '../models/config/registration-config.interface';

export const REGISTRATION_CONFIG = new InjectionToken<RegistrationConfig>(
  'registration config'
);
